/* eslint-disable no-nested-ternary */
import { MouseEvent } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  ctaConversion: (theme) => ({
    backgroundColor: theme.palette.care?.white,
    borderRadius: theme.spacing(3),
    minHeight: '136px',
    margin: theme.spacing(-2, 0),
    padding: theme.spacing(2, 0),
    width: '100%',
  }),
  ctaConversionBtn: (theme) => ({
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: '295px',
    height: '72px',
    padding: `${theme.spacing(2, 3)} !important`,
    border: `1px solid ${theme.palette.care.grey[300]}`,
    boxSizing: 'border-box',
    borderRadius: '16px',
    cursor: 'pointer',
    marginBottom: theme.spacing(0.2),
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: theme.typography.body1.fontSize,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '240px',
    },
  }),
  ctaButtonContainer: {
    margin: 1,
  },
};

interface SeniorCareConversionBoxProps {
  headline?: string;
  enrollmentURL?: string;
}

const SeniorCareConversionBox = ({ headline, enrollmentURL }: SeniorCareConversionBoxProps) => {
  const ctaLables = [
    {
      label: 'A loved one',
    },
    {
      label: 'Myself',
    },
  ];

  const handleCTABtn = (e: MouseEvent) => {
    const amplitudeData = {
      cta_location: 'header',
      cta_text: (e.target as HTMLElement).textContent?.toString(),
      cta_type: 'button',
    };
    trackAmplitudeEvent(AmplitudeEvent.monetateAssetClicked, amplitudeData);
  };

  const renderCtaBtns = () => {
    return ctaLables.map((item) => (
      <Box key={item.label} minWidth="144px" sx={classes.ctaButtonContainer}>
        <Button
          component="a"
          href={enrollmentURL}
          variant="outlined"
          color="secondary"
          size="medium"
          fullWidth
          sx={classes.ctaConversionBtn}
          data-testid="conversion-cta-link"
          onClick={handleCTABtn}
          rel="nofollow">
          {item.label}
        </Button>
      </Box>
    ));
  };
  return (
    <Grid container sx={classes.ctaConversion}>
      <Grid item xs={12}>
        <Typography
          variant="h2"
          align="center"
          color="textSecondary"
          fontSize="body1.fontSize"
          mb={2}>
          {headline}
        </Typography>
      </Grid>
      <Box display="flex" justifyContent="center" flexWrap="wrap" flexBasis="100%" m="">
        {renderCtaBtns()}
      </Box>
    </Grid>
  );
};

export default SeniorCareConversionBox;
